import React from 'react'

export default ({ inView }) => {
  const [isLoaded, setIsLoaded] = React.useState(false)
  const ScrollMagic = React.useRef(null)

  React.useEffect(() => {
    if (!isLoaded && inView) {
      const loadScrollMagic = async () => {
        ScrollMagic.current = (await import('ScrollMagic')).default
        setIsLoaded(true)
      }

      loadScrollMagic()
    }
  }, [isLoaded, inView])

  return {
    ScrollMagic: ScrollMagic.current,
    isScrollMagicLoaded: isLoaded,
  }
}
